import { render, staticRenderFns } from "./ShippingCountriesForm.vue?vue&type=template&id=acb5a202&scoped=true"
import script from "./ShippingCountriesForm.vue?vue&type=script&lang=js"
export * from "./ShippingCountriesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb5a202",
  null
  
)

export default component.exports